import React, { SVGAttributes } from 'react';

export function ErrorExclamationV2(props: SVGAttributes<unknown>): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      role='img'
      {...props}
    >
      <title>Exclamation Icon</title>
      <g clipPath='url(#clip0_7307_9643)'>
        <path
          d='M7.99994 0.500034C5.8585 0.533447 3.81605 1.40742 2.31327 2.93337C1.56527 3.68126 0.975081 4.57175 0.577703 5.55203C0.180325 6.5323 -0.016148 7.5824 -6.30274e-05 8.64003C-0.000941426 9.67303 0.201985 10.6961 0.597093 11.6505C0.992201 12.605 1.57173 13.4721 2.30248 14.2022C3.03323 14.9323 3.90084 15.5111 4.85563 15.9054C5.81041 16.2997 6.83361 16.5018 7.8666 16.5H7.99994C10.14 16.4807 12.1848 15.6124 13.6849 14.086C15.185 12.5596 16.0177 10.5001 15.9999 8.36003C16.0019 7.31544 15.7953 6.28097 15.3922 5.31729C14.9891 4.3536 14.3977 3.4801 13.6525 2.74801C12.9074 2.01592 12.0236 1.43998 11.0529 1.05396C10.0823 0.667943 9.04433 0.479619 7.99994 0.500034ZM6.99994 11.5267C6.99449 11.3927 7.01642 11.2589 7.0644 11.1337C7.11238 11.0084 7.1854 10.8942 7.27899 10.7982C7.37259 10.7021 7.48479 10.6261 7.60875 10.5748C7.73271 10.5236 7.86581 10.4981 7.99994 10.5C8.26251 10.5015 8.51439 10.6043 8.70314 10.7868C8.89189 10.9694 9.00298 11.2177 9.01327 11.48C9.01866 11.6121 8.9973 11.7438 8.95047 11.8674C8.90365 11.9909 8.83231 12.1037 8.74077 12.199C8.64923 12.2943 8.53936 12.3701 8.41778 12.4218C8.29619 12.4735 8.1654 12.5001 8.03327 12.5C7.76835 12.5038 7.51237 12.4043 7.3195 12.2226C7.12664 12.041 7.01203 11.7914 6.99994 11.5267ZM7.33327 8.86003V4.86003C7.33327 4.68322 7.40351 4.51365 7.52853 4.38863C7.65356 4.26361 7.82313 4.19337 7.99994 4.19337C8.17675 4.19337 8.34632 4.26361 8.47134 4.38863C8.59637 4.51365 8.6666 4.68322 8.6666 4.86003V8.86003C8.6666 9.03685 8.59637 9.20641 8.47134 9.33144C8.34632 9.45646 8.17675 9.5267 7.99994 9.5267C7.82313 9.5267 7.65356 9.45646 7.52853 9.33144C7.40351 9.20641 7.33327 9.03685 7.33327 8.86003Z'
          fill='#BE0517'
        />
      </g>
      <defs>
        <clipPath id='clip0_7307_9643'>
          <rect width='16' height='16' fill='white' transform='translate(0 0.5)' />
        </clipPath>
      </defs>
    </svg>
  );
}
